module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if(upSellExit === 'true') { %> <button class=\"banner\"> <p><%= copy %></p> <div class=\"button\"><%= promoResourceLinks[0].copy %></div> </button> <% } else { %> <a href=\"<%= promoResourceLinks[0].url %>\" class=\"banner\" target=\"_blank\"> <p><%= copy %></p> <div class=\"button\"><%= promoResourceLinks[0].copy %></div> </a> <% } %> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if(upSellExit === 'true') { ; buf.push(' <button class="banner"> <p>', escape((__stack.lineno=1,  copy )), '</p> <div class="button">', escape((__stack.lineno=1,  promoResourceLinks[0].copy )), '</div> </button> ');__stack.lineno=1; } else { ; buf.push(' <a href="', escape((__stack.lineno=1,  promoResourceLinks[0].url )), '" class="banner" target="_blank"> <p>', escape((__stack.lineno=1,  copy )), '</p> <div class="button">', escape((__stack.lineno=1,  promoResourceLinks[0].copy )), '</div> </a> ');__stack.lineno=1; } ; buf.push(' '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/global-banner.ejs
// module id = 252
// module chunks = 0